import es6Promise from 'es6-promise'
import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

es6Promise.polyfill()

// must call Vue.use(Vuex) before creating a store instance
Vue.use(Vuex)

const state = {
  user: {
    isAuthenticated: false,
    isAdmin: false,
    token: '',
    expiresIn: '',
    name: '',
    status: ''
  },
  routes: [],
  crushingDrugs: [],
  crushingDrugForms: [],
  eyedropDosages: [],
  eyedropGeneralRecommendation: {text: '', changeDate: ''},
  generalRecText: '',
  applicationDynamicTexts: {
    firstPageReadMore: {text: ''}
  },
  references: [],
  notes: [],
  dilutions: [],
  substitutions: [],
  pdf: {},
  contents: [],
  cities: [],
  miscibilitySubstances: [],
  reducedKidneyFunctionDrugs: [],
  staticTexts: {
    firstPageReadMore: {text: ''},
    privacyPolicy: {text: ''}
  },
  storageUpdateDate: {storageLastUpdateDate: '', deliveryLastUpdateDate: ''},
  versions: {}
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})
